import { Routes, Route } from 'react-router-dom'
import WebMessagePage from './components/WebMessage'
import Sent from './components/Sent'

function App() {
	return (
		<div>
			<Routes>
				<Route path='/' element={<WebMessagePage />} />
				<Route path='/sent' element={<Sent />} />
			</Routes>
		</div>
	)
}

export default App
